import type { RouteObject } from 'react-router-dom';
import {
  bannersRoutePath,
  customersRoutePath,
  distributorsRoutePath,
  downloadsUploadsRoutePath,
  homeRoutePath,
  maintenanceRoutePath,
  masiveExportsRoutePath,
  navigationTreeRoutePath,
  ordersRoutePath,
  productsRoutePath,
  promotionsRoutePath,
  shortcutsRoutePath,
  staticPagesRoutePath,
  suggestedProductRoutePath,
  usersRoutePath,
  yapeRoutePath,
} from 'core/constants/routes.constants';

export interface IProtectedRoutes {
  path: string;
  getLazyComponent?: () => Promise<any>;
}

export const protectedRoutes: Array<IProtectedRoutes> = [
  {
    path: homeRoutePath,
    getLazyComponent: () => import('screens/home'),
  },
  {
    path: customersRoutePath,
    getLazyComponent: () => import('screens/customers'),
  },
  {
    path: productsRoutePath,
    getLazyComponent: () => import('screens/product-management'),
  },
  {
    path: navigationTreeRoutePath,
    getLazyComponent: () => import('screens/navigation-tree'),
  },
  {
    path: ordersRoutePath,
    getLazyComponent: () => import('screens/orders'),
  },
  {
    path: distributorsRoutePath,
    getLazyComponent: () => import('screens/logistics/distributors'),
  },
  {
    path: suggestedProductRoutePath,
    getLazyComponent: () => import('screens/suggested-product'),
  },
  {
    path: bannersRoutePath,
    getLazyComponent: () => import('screens/banners'),
  },
  {
    path: shortcutsRoutePath,
    getLazyComponent: () => import('screens/shortcuts'),
  },
  {
    path: maintenanceRoutePath,
    getLazyComponent: () => import('screens/maintenance'),
  },
  {
    path: masiveExportsRoutePath,
    getLazyComponent: () => import('screens/massive-loads/masive-exports'),
  },
  {
    path: promotionsRoutePath,
    getLazyComponent: () => import('screens/promotions'),
  },
  {
    path: usersRoutePath,
    getLazyComponent: () => import('screens/users'),
  },
  {
    path: staticPagesRoutePath,
    getLazyComponent: () => import('screens/static-pages'),
  },
  {
    path: yapeRoutePath,
    getLazyComponent: () => import('screens/yape'),
  },
  {
    path: downloadsUploadsRoutePath,
    getLazyComponent: () => import('screens/downloads-uploads'),
  },
];

export const getRoutesFromMenuRoutes = (menuRoutes: Array<IProtectedRoutes>): Array<RouteObject> =>
  menuRoutes.map(item => ({
    path: `${item.path.replace(/^\//, '')}/*`,
    async lazy() {
      const module = await item.getLazyComponent?.();
      if (!module) {
        throw new Error('Module not found');
      }
      return { Component: module.default };
    },
  }));
